import * as React from "react";
function SvgArrowsSpread(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        stroke="currentColor"
        d="M9 1H1v8M13 13L2 2M23 31h8v-8M19 19l11 11M31 9V1h-8M19 13L30 2M1 23v8h8M13 19L2 30"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgArrowsSpread);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
